<template>
    <div class="py-4 container-fluid">
        <div class="mt-4 row">
            <div class="col-12">
                <div class="card">
                    <!-- Card header -->
                    <div class="card-header border-bottom">
                        <div class="row d-flex align-items-center">
                            <div class="col-6">
                                <h5 class="mb-0">Almérő Regisztráció</h5>
                            </div>
                            <div class="col-6 text-end">
                                <material-button class="float-right btn btm-sm"
                                    @click="this.$router.push({ name: 'SubMeters List' })">
                                    Vissza
                                </material-button>
                            </div>
                        </div> 
                    </div>
                    <!--Card body-->
                    <div class="card-body">
                        <form>
                            <div class="row">
                                <div class="col-5">
                                    <label class="form-label mb-0 ms-0">POD</label>
                                    <select id="choices-pod" v-model.number="submeter.pod" name="choices-pod" class="form-control" @change="setRealEstate($event.target.value)">
                                        <option v-for="utility in UtilitiesList" :key="utility.id" :value="utility.id">{{ utility.pod }}</option>
                                    </select>
                                    <validation-error :errors="apiValidationErrors.pod"></validation-error>
                                </div>

                                <div class="col-5">
                                    <material-input id="realestate_name" v-model:value="submeter.realestate_name" label="Hely neve"
                                        name="realestate_name" variant="static"></material-input>
                                </div>

                                <div class="col-5">
                                    <material-input id="realestate_address" v-model:value="submeter.realestate_address" label="Hely címe"
                                        name="realestate_address" variant="static"></material-input>
                                </div>

                                <div class="col-5">
                                    <label class="form-label mb-0 ms-0">Főmérő gyári szám</label>
                                    <select id="choices-meter_pod" v-model.number="submeter.meter_pod" name="choices-meter_pod" class="form-control">
                                        <option v-for="meter in metersList" :key="meter.id" :value="meter.id">{{ meter.product_number }}</option>
                                    </select>
                                    <validation-error :errors="apiValidationErrors.meter_pod"></validation-error>
                                </div>
                            </div>

                            <br />

                            <div class="row p-4 bg-light">
                                <div class="col-5">
                                    <material-input id="product_number" v-model:value="submeter.product_number" label="Gyári szám"
                                        name="product_number" variant="static"></material-input>
                                    <validation-error :errors="apiValidationErrors.product_number"></validation-error>
                                </div>

                                <div class="col-5">
                                    <label class="form-label mb-0 ms-0">Mérési egység</label>
                                    <select id="choices-munits" v-model="submeter.measurement_units_id" name="choices-munits" class="form-control">
                                        <option v-for="unit in getMeasurementUnitsList" :key="unit.id" :value="unit.id">{{ unit.name }}</option>
                                    </select>
                                </div>

                                <div class="col-5">
                                    <label class="form-label mb-0 ms-0">Típus</label>
                                    <select id="choices-stypes" v-model="submeter.submeter_types_id" name="choices-stypes" class="form-control">
                                        <option v-for="type in getSubmeterTypesList" :key="type.id" :value="type.id">{{ type.name }}</option>
                                    </select>
                                </div>

                                <div class="col-5">
                                    <label class="form-label mb-0 ms-0">Beüzemelés időpontja</label>
                                    <VueDatePicker id="selected-date" v-model="currentDate" :teleport="true" :format-locale="hu" :locale="hu" :format="format" :enable-time-picker="false" select-text="Választ" cancel-text="Bezár"/>
                                </div>

                                <div class="col-5">
                                    <label class="form-label mb-0 ms-0">Pozíció</label>
                                    <select id="choices-position" v-model="submeter.position" name="choices-position" class="form-control">
                                        <option v-for="area in AreaList" :key="area.id" :value="area.id">{{ area.area_nr }}</option>
                                    </select>
                                </div>
                                
                                <div class="col-5">
                                    <label>Heylségek hozzáadása</label>
                                    <MultiSelect v-model:selectValue="submeter.area_ids" :options="areas" select-all="true" select-all-label="Mindet kijelöl" cleaner="false" @show="() => setChoice()" />
                                    <validation-error :errors="apiValidationErrors.area_ids"></validation-error>
                                </div>
                            </div>

                            <div class="row mt-2 mb-5 d-flex align-items-center">
                                <div class="col-2 text-end mt-5">
                                    <material-button class="float-right btn btm-sm" @click.prevent="handleAdd">Hozzáadás</material-button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Choices from 'choices.js';
import { ref } from 'vue';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/formMixin.js";
import showSwal from "../../../mixins/showSwal";
import MultiSelect from "@/components/MultiSelect.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import { hu } from 'date-fns/locale';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    name: 'AddSubMeter',
    components: {
        MaterialButton,
        MaterialInput,
        VueDatePicker,
        MultiSelect,
        ValidationError
    },
    mixins: [formMixin],
    setup() {
        const currentDate = ref(new Date());
        const areas = ref([]);
        const format = (date) => {
            const day = date.getDate() < 9 ? "0" + date.getDate() : date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            return `${year}-${month}-${day}`;
        };
        return {
            color: '#33e8f5',
            currentDate,
            hu,
            format,
            areas,
        }
    },
    data() {
        return {
            submeter: {},
            date: null,
            metersList: {},
        }
    },
    computed: {
        getRealEstateList() {
            return this.$store.getters["realestates/getRealEstatesData"];
        },
        getMeasurementUnitsList() {
            return this.$store.getters["munits/getMunitsData"];
        },
        getSubmeterTypesList() {
            return this.$store.getters["stypes/getStypesData"];
        },
        UtilitiesList() {
            return this.$store.getters["unetworks/getUnetworksData"];
        },
        AreaList() {
            return this.$store.getters["areas/getAreasData"];
        },
        watch: {
            AreaList: function () {
                this.setChoice();
            },
            metersList: function () {
                this.setChoice();
            },
        },
    },
    async mounted() {
        await this.$store.dispatch("realestates/getRealEstates");
        await this.$store.dispatch("unetworks/getUnetworks");
        await this.$store.dispatch("areas/getAreas");
        await this.$store.dispatch("munits/getMunits");
        await this.$store.dispatch("stypes/getStypes");

        if (document.getElementById("choices-pod")) {
            var pod = document.getElementById("choices-pod");
            this.pod = new Choices(pod);
            this.currentRealEstate = this.getRealEstateList.filter(value => {
                return value.id.includes(this.pod.getValue(true))
            });
            await this.$store.dispatch("areas/getAreas", {
                filter: {
                    ...(this.pod.getValue(true) ? { realestate_id: this.pod.getValue(true) } : {}),
                },
            })
            await this.$store.dispatch("meters/getMeters", {
                filter: {
                    ...(this.pod.getValue(true) ? { pod: this.pod.getValue(true) } : {}),
                },
            })
            .then(() => {
                this.metersList = this.$store.getters["meters/getMetersData"];
            });

            document.getElementById('realestate_name').value = this.currentRealEstate[0].name;
            document.getElementById('realestate_address').value = this.currentRealEstate[0].zip + ' ' + this.currentRealEstate[0].city + ' ' +  this.currentRealEstate[0].address;
            this.submeter.pod = parseInt(this.pod.getValue(true));
        }

        if (document.getElementById("choices-munits")) {
            var munits = document.getElementById("choices-munits");
            this.munits = new Choices(munits);
            this.submeter.measurement_units_id = parseInt(this.munits.getValue(true));
        }

        if (document.getElementById("choices-position")) {
            var position = document.getElementById("choices-position");
            this.position = new Choices(position);
            this.submeter.position = String(this.position.getValue(true));
        }

        if (document.getElementById("choices-stypes")) {
            var stype = document.getElementById("choices-stypes");
            this.stype = new Choices(stype);
            this.submeter.submeter_types_id = String(this.stype.getValue(true));
        }

        if (document.getElementById("choices-meter_pod")) {
            var meter_pod = document.getElementById("choices-meter_pod");
            this.meter_pod = new Choices(meter_pod);
            this.submeter.meter_pod = String(this.meter_pod.getValue(true));
        }
    },
    methods: {
        async handleAdd() {
            this.resetApiValidation();
            try {
                this.submeter.currentDate = this.currentDate;
                await this.$store.dispatch("submeters/addSubMeter", this.submeter);
                showSwal.methods.showSwal({
                        type: "success",
                        message: "Almérő sikeresen hozzáadva!",
                        width: 500
                    });
                this.$router.push({ name: "SubMeters List" })
            } catch (error) {
                if (error.response.data.errors) {
                    this.setApiValidation(error.response.data.errors);
                }
                showSwal.methods.showSwal({
                    type: "error",
                    message: "Valami hiba történt!",
                    width: 500
                });

            }
        },
        async setRealEstate(event) {
            await store.dispatch("meters/getMeters", {
                filter: {
                    ...(event ? { pod: event } : {}),
                },
            })
            .then(() => {
                this.metersList = this.$store.getters["meters/getMetersData"];
            });
            this.currentRealEstate = this.getRealEstateList.filter(value => {
                return value.id.includes(event)
            });
            document.getElementById('realestate_address').value = this.currentRealEstate[0].name;
        },
        setChoice() {
            this.areas = this.AreaList.map((item) => ({
                value: item.id, 
                label: item.area_nr,
            }));
        },
    }
}
</script>